module.exports = __webpack_public_path__ + "static/media/espn_nfl_story___id_15472532_how-reche-caldwell-googled-way-patriots-prison_plot.e002d219.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/espn_nfl_story___id_15472532_how-reche-caldwell-googled-way-patriots-prison_plot.png
// module id = 389
// module chunks = 0